import Analytics from "./src/Analytics";

// For any domain related functionallity touch this file

/**
 * @type {Analytics}
 */
let analyticsInstance;

const set = analytics => {
  if (analyticsInstance) throw new Error("analytics instance was already set");
  analyticsInstance = analytics;
};

const get = () => {
  if (!analyticsInstance) throw new Error("must call set before get");
  return analyticsInstance;
};

const secondsToMiliseconds = seconds => Math.round(seconds * 1000);

const skipTrack = (songTitle, playbackPosition, type = "music") => {
  get().event({
    category: type + "s",
    action: "skip",
    label: songTitle,
    value: secondsToMiliseconds(playbackPosition),
  });
};

const previousTrack = (songTitle, playbackPosition, type = "music") => {
  get().event({
    category: type + "s",
    action: "previous",
    label: songTitle,
    value: secondsToMiliseconds(playbackPosition),
  });
};

const downloadWrapper = (songTitle, songDuration, category) => {
  get().event({
    category,
    action: "download",
    label: songTitle,
    value: songDuration,
  });
};

const downloadVoice = (songTitle, songDuration) => downloadWrapper(songTitle, songDuration, "voices");

const downloadMusic = songTitle => get().event({ category: "musics", action: "download", label: songTitle });

const downloadDemo = songTitle => get().event({ category: "musics", action: "demo", label: songTitle });

const playMusic = (songTitle, songAlbum) =>
  get().event({
    category: "musics",
    action: "play",
    label: `${songTitle}-${songAlbum}`,
  });

const closeSoundbar = () => {
  get().event({
    category: "soundbar",
    action: "close",
  });
};

const smartSearch = searchTags =>
  get().event({
    category: "search",
    action: "smart",
    label: (() => {
      searchTags.sort();
      return searchTags.join("-");
    })(),
  });

const navSearch = query => get().event({ category: "search", action: "nav", label: query });

const addTrackToPlaylist = (playlistName, trackName) =>
  get().event({ category: "playlists", action: "add", label: `${playlistName}-${trackName}` });

const createPlaylist = playlistName => get().event({ category: "playlists", action: "create", label: playlistName });

const newSavedQuery = savedQueryName =>
  get().event({ category: "savedQueries", action: "create", label: savedQueryName });

const removeSavedQuery = savedQueryName =>
  get().event({ category: "savedQueries", action: "remove", label: savedQueryName });

const addMusicToFavorites = musicName => {
  get().event({ category: "favorites", action: "addMusic", label: musicName })
};

const removeMusicFromFavorites = musicName =>
  get().event({ category: "favorites", action: "removeMusic", label: musicName });

const addAlbumToFavorites = albumName => get().event({ category: "favorites", action: "addAlbum", label: albumName });

const removeAlbumFromFavorites = albumName =>
  get().event({ category: "favorites", action: "removeAlbum", label: albumName });

const addSpeakerToFavorites = speakerName =>
  get().event({ category: "favorites", action: "addSpeaker", label: speakerName });

const removeSpeakerFromFavorites = speakerName =>
  get().event({ category: "favorites", action: "removeSpeaker", label: speakerName });

const newLicense = (country, licenseType, trackName) =>
  get().event({ category: "license", action: `${country}-${licenseType}`, label: trackName });

const viewSpeaker = speakerName => get().event({ category: "open", action: "speaker", label: speakerName });

const viewAlbum = albumTitle => get().event({ category: "open", action: "album", label: albumTitle });

const viewPlaylist = playlistTitle => get().event({ category: "open", action: "playlist", label: playlistTitle });

export default {
  set,
  get,
  skipTrack,
  previousTrack,
  closeSoundbar,
  downloadMusic,
  playMusic,
  downloadVoice,
  smartSearch,
  navSearch,
  addTrackToPlaylist,
  createPlaylist,
  newSavedQuery,
  removeSavedQuery,
  addMusicToFavorites,
  removeMusicFromFavorites,
  downloadDemo,
  newLicense,
  viewSpeaker,
  viewAlbum,
  viewPlaylist,
  addAlbumToFavorites,
  removeAlbumFromFavorites,
  addSpeakerToFavorites,
  removeSpeakerFromFavorites,
};
